export default {
  home: "Accueil",
  explore: "Explorer",
  bookings: "Réservations",
  profile: "Profil",
  dashboard: "Tableau de bord",
  messages: "Messages",
  earnings: "Revenus",

  signOut: "Se déconnecter",
  save: "Enregistrer",
  cancel: "Annuler",
  back: "Retour",
  loading: "Chargement...",
  submit: "Soumettre",
  online: "En ligne",
  offline: "Hors ligne",

  welcomeBack: "Bon retour",
  elevateSpace: "Élevez votre espace avec Mouna.",
  discovery: "DÉCOUVERTE",
  curatedServices: "Services Sélectionnés",
  allCategories: "Toutes les Catégories",
  activeAssignments: "Missions Actives",

  findArtisan: "Trouvez votre artisan.",
  startingFrom: "À partir de",
  bookNow: "Réserver maintenant",
  proVerified: "PRO VÉRIFIÉ",

  myBookings: "Mes Réservations",
  pending: "en attente",
  confirmed: "confirmé",
  completed: "terminé",
  help: "Aide",

  professionalDashboard: "TABLEAU DE BORD PROFESSIONNEL",
  newLeads: "Nouveaux Clients",
  accept: "Accepter",
  decline: "Refuser",
  totalEarnings: "REVENUS TOTAUX",
  leadPricing: "Tarification des Clients",
  myPublicProfile: "Mon Profil Public",
  portfolio: "Portfolio",
  supportTickets: "Tickets de Support",

  requestQuote: "Demander un Devis",
  jobSize: "Taille du Travail",
  describeJob: "Décrivez votre Travail",
  serviceAddress: "Adresse du Service",
  preferredDate: "Date et Heure Préférées",
  sendQuoteRequest: "Envoyer la Demande",
  privateNotes: "Notes Privées pour le Pro (optionnel)",
  addPhotos: "Ajouter des Photos ou Vidéos (optionnel)",

  howCanWeHelp: "Comment pouvons-nous vous aider?",
  modifyBooking: "Modifier la réservation",
  cancelBooking: "Annuler la réservation",
  messageProvider: "Message au prestataire",
  issueWithService: "Problème avec le service",
  billingIssue: "Problème de facturation",

  signIn: "Se connecter",
  signUp: "S'inscrire",
  email: "Email",
  password: "Mot de passe",
  noAccount: "Pas de compte? Inscrivez-vous",
  haveAccount: "Vous avez un compte? Connectez-vous",

  leaveReview: "Laisser un Avis",
  submitReview: "Soumettre l'Avis",
  respond: "Répondre",

  contactSupport: "Contacter le Support",
  myTickets: "Mes Tickets de Support",
  getHelp: "Obtenir de l'Aide",
};
